import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "calendar-empty-day"
}

import { computed, ref } from 'vue';
  import isTodayFNS from 'date-fns/is_today';
  import isSameDay from 'date-fns/is_same_day';
  import Emitter, { EVENT_NAMES } from '@/plugins/emitter';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DayButton',
  props: {
    dates: {
      type: Array<Date>,
      default: [],
    },
    day: Date,
    disabled: Boolean,
  },
  setup(__props) {

const props = __props

  

  const hovered = ref<boolean>(false);

  const isNotEmpty = computed(() => {
    return !!props.day;
  });

  const isSelected = computed(() => {
    return props.day ? props.dates.some(it => isSameDay(it, props.day)) : false;
  });

  const isInDate = computed(() => {
    return (
      props.day &&
      props.dates.length > 1 &&
      props.dates[1] != undefined &&
      props.dates[1] != null &&
      props.dates[0] &&
      isSameDay(props.day, props.dates[0])
    );
  });

  const isOutDate = computed(() => {
    return (
      props.day &&
      props.dates.length > 1 &&
      props.dates[1] != undefined &&
      props.dates[1] != null &&
      props.dates[1] &&
      isSameDay(props.day, props.dates[1])
    );
  });

  const isToday = computed(() => {
    return props.day && isTodayFNS(props.day);
  });

  const dayStyle = computed(() => {
    const style =
      isToday.value && isSelected.value
        ? {
            'calendar-day-text': true,
            'calendar-today-text': false,
            'calendar-weekdays': !isToday.value && !isSelected.value,
            'calendar-day-selected': isSelected.value,
            'calendar-day-selected-text': isSelected.value,
          }
        : {
            'calendar-day-text': true,
            'calendar-today-text': isToday.value,
            'calendar-weekdays': !isToday.value && !isSelected.value,
            'calendar-day-selected': isSelected.value,
            'calendar-day-selected-text': isSelected.value,
          };

    if (hovered.value && !isSelected.value) {
      if (isToday.value) {
        style['calendar-today-text'] = !style['calendar-today-text'];
      } else {
        style['calendar-weekdays'] = !style['calendar-weekdays'];
      }
      style['calendar-day-selected-text'] =
        !style['calendar-day-selected-text'];
    }

    return style;
  });

  const hoverStyle = computed(() => {
    const style = isSelected.value
      ? {
          'calendar-day-bg': true,
          'calendar-day-bg-selected': true,
          'calendar-day-hover': false,
        }
      : {
          'calendar-day-bg': true,
          'calendar-day-bg-selected': false,
          'calendar-day-hover': false,
        };

    if (!isSelected.value) {
      style['calendar-day-hover'] = hovered.value;
    }

    return style;
  });

  const buttonStyle = computed(() => {
    return {
      'calendar-day-button': !props.disabled,
      'calendar-day-button-disabled': props.disabled,
      'calendar-checkin-day': isInDate.value,
      'calendar-checkout-day': props.dates[0] && isOutDate.value,
    };
  });

  function toDate(day) {
    return day.getDate();
  }
  function hoverIn() {
    if (!props.disabled) {
      hovered.value = true;
    }
  }
  function hoverOut() {
    if (!props.disabled) {
      hovered.value = false;
    }
  }
  function select() {
    Emitter.$emit(EVENT_NAMES.CALENDAR_UPDATE_SELECTED, props.day);
  }

return (_ctx: any,_cache: any) => {
  return (_unref(isNotEmpty))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(["day-button", _unref(buttonStyle)]),
        onClick: select,
        onMouseenter: hoverIn,
        onMouseleave: hoverOut,
        disabled: __props.disabled,
        tabindex: "0",
        type: "button"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_unref(hoverStyle))
        }, null, 2),
        _createElementVNode("span", {
          class: _normalizeClass(_unref(dayStyle))
        }, _toDisplayString(toDate(__props.day)), 3)
      ], 42, _hoisted_1))
    : (_openBlock(), _createElementBlock("span", _hoisted_2))
}
}

})